import React, { use, useEffect, useRef, useState } from "react";
import categoryModel from "../../model/category.model";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Card from "../../component/productlist/Card";
import { toast } from "../../lib/helper";
import back from "../../Asset/product/back.png";
import { type } from "@testing-library/user-event/dist/type";
import { AiOutlineAppstore } from "react-icons/ai";
import { MdKeyboardArrowDown } from "react-icons/md";
import { FaArrowDown } from "react-icons/fa";
import { FaArrowUp } from "react-icons/fa";

const Productlist = () => {
  const location = useLocation();
  const [filter, setFilter] = useState("Sort By");
  const [showDropdown, setShowDropdown] = useState(false);
  const buttonRef = useRef(null);
  const dropdownRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location?.pathname]);

  const parms = useParams();
  const [categorylist, setCategoryList] = useState();
  const [categoryProduct, setCategoryProduct] = useState();
  const [catename, setCatename] = useState();

  const Navigate = useNavigate();

  const Categorylist = async () => {
    categoryModel
      .GetList(parms?.mid)
      .then((responce) => {
        setCategoryList(responce?.data?.data);
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  useEffect(() => {
    Categorylist();
    Categoryproduct();
    categoryname();
  }, [location]);

  const Categoryproduct = async () => {
    setLoading(true);
    try {
      let query = "";

      if (filter === "Low to high") {
        query = "&sort_by_price=low_to_high";
      } else if (filter === "High to low") {
        query = "&sort_by_price=high_to_low";
      }

      const response = await categoryModel.GetproductByCategory(
        parms?.id,
        query
      );
      const products = response?.data?.data;
      setLoading(false);
      setCategoryProduct(products);
    } catch (error) {
      console.log("error:", error);
      setLoading(false);
    }
  };

  const categoryname = async () => {
    categoryModel
      .CategoryDetail(parms?.id)
      .then((responce) => {
        setCatename(responce?.data?.data);
        console.log("category name", responce);
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  useEffect(() => {
    Categoryproduct();
  }, [filter]);
  return (
    <div
      className="bg-Background7  w-full pb-52"
      style={{ backgroundImage: `url(${back})` }}
    >
      <div className="flex flex-col md:flex-row w-full mt-7 gap-1">
        <div
          className="p-2 md:p-4 w-full md:w-[190px] 2xl:[200px] h-36 md:h-screen 
  overflow-x-auto md:overflow-x-hidden 
  overflow-y-hidden md:overflow-y-auto 
  flex flex-row md:flex-col gap-2 scroll-smooth snap-x md:snap-none "
        >
          {categorylist?.map((item, index) => {
            return (
              <div
                className={`${
                  parms?.id == item?._id ? "bg-Background2" : ""
                } p-2 md:p-4 rounded-3xl cursor-pointer w-36 h-full md:w-full md:h-44 flex flex-col justify-center items-center`}
                key={index}
                onClick={() => {
                  Navigate(`/product/${item?._id}/${item?.type}`);
                }}
              >
                <div className=" bg-Background1 rounded-3xl flex items-center justify-center w-16 h-16 md:w-full md:h-fit">
                  <img
                    src={item?.image?.location}
                    alt="gg"
                    className="p-2 w-full h-full"
                  />
                </div>
                <div className="w-full mt-2 flex justify-center ">
                  <span className=" text-textColor text-center whitespace-normal md:whitespace-nowrap font-semibold md:text-sm lg:text-base text-xs">
                    {item?.name}
                  </span>
                </div>
              </div>
            );
          })}
        </div>

        <div className=" w-full pl-0 md:pl-3 2xl:pl-4  pr-2 md:pr-12 md:py-8 py-2 px-4">
          <div className="flex  md:flex-row justify-between md:items-center items-start px-4 md:px-0 ">
            <span className="text-textColor text-lg md:text-2xl font-bold title">
              {catename?.name}
            </span>
            <div className="relative inline-block w-40">
              <div
                className="flex items-center justify-between bg-textColor text-white px-3 py-0 md:py-1 rounded-xl cursor-pointer"
                ref={buttonRef}
                onClick={() => setShowDropdown((prev) => !prev)}
              >
                <div className="flex  gap-2 items-center">
                {filter == "Sort By" && (
                  <AiOutlineAppstore className="text-xl" />
                )}
                {filter == "Low to high" && (
                  <FaArrowUp className="text-base" />
                )}
                {filter == "High to low" && (
                  <FaArrowDown className="text-base" />
                )}
                {filter}
                </div>
                <MdKeyboardArrowDown />
              </div>

              {showDropdown && (
                <div
                  className="absolute right-0 mt-2 w-40 bg-white shadow-lg z-50 rounded-xl"
                  ref={dropdownRef}
                >
                  <ul className="py-1">
                    <li
                      className="px-4 py-2 hover:bg-gray-100 cursor-pointer border-b border-textColor "
                      onClick={() => {
                        setFilter("Sort By");
                        setShowDropdown(false);
                      }}
                    >
                      <div className="w-full flex gap-2 items-center">
                        <AiOutlineAppstore className="text-lg md:text-xl" />{" "}
                        Sort By
                      </div>
                    </li>
                    <li
                      className="px-4 py-2 hover:bg-gray-100 cursor-pointer border-b border-textColor "
                      onClick={() => {
                        setFilter("Low to high");
                        setShowDropdown(false);
                      }}
                    >
                      <div className="w-full flex gap-2 items-center">
                        <FaArrowUp /> Low to high
                      </div>
                    </li>
                    <li
                      className="px-4 py-2 hover:bg-gray-100 cursor-pointer "
                      onClick={() => {
                        setFilter("High to low");
                        setShowDropdown(false);
                      }}
                    >
                      <div className="w-full flex gap-2 items-center">
                        <FaArrowDown /> High to low
                      </div>
                    </li>
                  </ul>
                </div>
              )}
            </div>
          </div>
          {!loading ? (
            <div className="mt-8 grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8 xl:gap-4  2xl:gap-8">
              {categoryProduct?.map((item, index) => {
                return <Card item={item} key={index} />;
              })}
            </div>
          ) : (
            <div className="w-full flex justify-center items-center py-5">
              wait...
              <span className="loading loading-ball loading-xs"></span>
              <span className="loading loading-ball loading-sm"></span>
              <span className="loading loading-ball loading-md"></span>
              <span className="loading loading-ball loading-lg"></span>
              <span className="loading loading-ball loading-xl"></span>
            </div>
          )}
          {!loading && categoryProduct?.length === 0 && (
            <div className="w-full flex text-xl md:text-xl text-textColor font-semibold justify-center items-center">
              No Product Found
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Productlist;
